import React from 'react';

function getRimagePrioritiesOptions(): React.ReactNode[] {
  let options: React.ReactNode[] = [];
  for (let i = 0; i < 10; i++) {
    options.push(<option key={'rimageOption' + i}>{i}</option>);
  }
  return options;
}

export default getRimagePrioritiesOptions;
